module.exports = __webpack_public_path__ + "assets/img/SP.e44c5fbf.png";